import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import FileSaver from "file-saver";
import {
  deleteProductSuggestionService,
  getSuggestionsListService,
} from "../../../Services/ApiServices";
import {
  CommonApiActionsResponseDataProps,
  SuggetionsListItemProps,
  SuggetionsListResponseProps,
} from "../../../@types/api_response";
import Loader from "../../../SharedComponents/Loader/Loader";
import { DeleteConfirmation } from "../../../Modal/DeleteConfirmation";
import LeftArrow from "../../../Assets/modal_left_arrow.png";
import RightArrow from "../../../Assets/modal_right_arrow.png";
import searchIcon from "../../../Assets/searchFilter.png";
import deleteIcon from "../../../Assets/delete.svg";
import downloadIcon from "../../../Assets/download_icon.png";
import Styles from "./SuggestionsList.module.css";
import moment from "moment";

interface FilterDataProps {
  name: string;
  brand_name: string;
  description: string;
  units: string;
  customer_name: string;
  customer_mobile: string;
}

const defaultFilter: FilterDataProps = {
  name: "",
  brand_name: "",
  description: "",
  units: "",
  customer_name: "",
  customer_mobile: "",
};

export default function SuggestionsList() {
  const [tableData, setTableData] =
    useState<SuggetionsListResponseProps | null>(null);
  const [page, setPage] = useState(0);
  const [isLoader, setIsLoader] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState<FilterDataProps>(defaultFilter);
  const [ShowDelete, setShowDelete] = useState<{
    status: boolean;
    data: SuggetionsListItemProps | null;
  }>({ status: false, data: null });

  useEffect(() => {
    suggestionsListApiCall();
  }, []);

  const suggestionsListApiCall = (pageNumber = 1, isDownload = false) => {
    setIsLoader(true);
    const formData = new FormData();
    formData.append("customer_name", filterData.customer_name);
    formData.append("customer_mobile", filterData.customer_mobile);
    formData.append("name", filterData.name);
    formData.append("brand_name", filterData.brand_name);
    formData.append("description", filterData.description);
    formData.append("units", filterData.units);
    formData.append("is_download", isDownload ? "1" : "0");

    getSuggestionsListService(pageNumber, 10, formData)
      .then((res: AxiosResponse<SuggetionsListResponseProps | string>) => {
        if (isDownload && typeof res.data === "string") {
          let url = res.data;
          let urlArr = url.split(".");
          let ext = urlArr[urlArr.length - 1];
          let dateTime =
            moment().format("DD-MM-YYYY") + "," + moment().format("hh:mm:ss a");
          let fileName = dateTime + "." + ext;
          FileSaver.saveAs(url, fileName);
        } else if (typeof res.data === "object") {
          setTableData(res.data);
          setPage(pageNumber - 1);
        }
      })
      .catch((err: any) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const deleteSuggestionApiCall = () => {
    if (!ShowDelete.data) return;
    setIsLoader(true);
    const formData = new FormData();
    formData.append("suggestion_id", String(ShowDelete.data.suggestion_id));
    deleteProductSuggestionService(formData)
      .then((res: AxiosResponse<CommonApiActionsResponseDataProps>) => {
        toast.success("Suggestion deleted successfully");
        setShowDelete({ status: false, data: null });
        suggestionsListApiCall(tableData?.page ?? 1);
      })
      .catch((err: any) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleReset = () => {
    setFilterData(defaultFilter);
    suggestionsListApiCall(1);
  };

  return (
    <div className={Styles.parentContainer + " container-fluid"}>
      <Loader isLoader={isLoader} />

      {ShowDelete.status ? (
        <DeleteConfirmation
          isOpen={ShowDelete.status}
          onHide={() => setShowDelete({ status: false, data: null })}
          onSucess={deleteSuggestionApiCall}
        />
      ) : null}

      <div className={Styles.childContainerParent}>
        <div className={Styles.childContainer}>
          <div className={Styles.searchParentContainer}>
            <p className="fontBold align-self-center">
              Suggestions <span className="orange">List</span>
            </p>
            <div
              className={Styles.actionButtonsContainer + " align-self-center"}
            >
              <img
                className={Styles.searchIcon}
                src={searchIcon}
                alt="search"
                onClick={() => setShowFilter(!showFilter)}
              />
              <button
                className={Styles.CsvBtn + " kstoreFont"}
                onClick={() => {
                  suggestionsListApiCall(tableData?.page ?? 1, true);
                }}
              >
                Export to Csv
                <img
                  className={Styles.download}
                  src={downloadIcon}
                  alt="download"
                />
              </button>
            </div>
          </div>

          {showFilter ? (
            <div className={Styles.filterParentContainer + " row"}>
              <div className={Styles.categories + " col-md-3 col-sm-12"}>
                <label className="label">Customer Name</label>
                <input
                  type="text"
                  placeholder="Customer name"
                  className={Styles.filterInput + " contentFont"}
                  value={filterData.customer_name}
                  onChange={(e) =>
                    setFilterData({
                      ...filterData,
                      customer_name: e.target.value,
                    })
                  }
                />
              </div>
              <div className={Styles.categories + " col-md-3 col-sm-12"}>
                <label className="label">Customer Mobile</label>
                <input
                  type="text"
                  placeholder="Customer mobile"
                  className={Styles.filterInput + " contentFont"}
                  value={filterData.customer_mobile}
                  onChange={(e) =>
                    setFilterData({
                      ...filterData,
                      customer_mobile: e.target.value,
                    })
                  }
                />
              </div>
              <div className={Styles.categories + " col-md-3 col-sm-12"}>
                <label className="label">Product Name</label>
                <input
                  type="text"
                  placeholder="Product name"
                  className={Styles.filterInput + " contentFont"}
                  value={filterData.name}
                  onChange={(e) =>
                    setFilterData({ ...filterData, name: e.target.value })
                  }
                />
              </div>
              <div className={Styles.categories + " col-md-3 col-sm-12"}>
                <label className="label">Brand Name</label>
                <input
                  type="text"
                  placeholder="Brand name"
                  className={Styles.filterInput + " contentFont"}
                  value={filterData.brand_name}
                  onChange={(e) =>
                    setFilterData({ ...filterData, brand_name: e.target.value })
                  }
                />
              </div>
              <div className={Styles.categories + " col-md-3 col-sm-12"}>
                <label className="label">Units</label>
                <input
                  type="text"
                  placeholder="Units"
                  className={Styles.filterInput + " contentFont"}
                  value={filterData.units}
                  onChange={(e) =>
                    setFilterData({ ...filterData, units: e.target.value })
                  }
                />
              </div>
              <div className={Styles.categories + " col-md-3 col-sm-12"}>
                <label className="label">Description</label>
                <input
                  type="text"
                  placeholder="Description"
                  className={Styles.filterInput + " contentFont"}
                  value={filterData.description}
                  onChange={(e) =>
                    setFilterData({
                      ...filterData,
                      description: e.target.value,
                    })
                  }
                />
              </div>

              <div
                className={
                  Styles.searchBtnParent +
                  " d-flex justify-content-end col-8 pt-2"
                }
              >
                <button
                  onClick={handleReset}
                  className={Styles.resetBtn + " me-2"}
                >
                  Reset
                </button>
                <button
                  onClick={() => suggestionsListApiCall(1)}
                  className={Styles.searchBtn}
                >
                  Search
                </button>
              </div>
            </div>
          ) : null}

          <div className={Styles.tableParentContainer}>
            <div className={Styles.TableChildContainer}>
              <table>
                <thead>
                  <tr>
                    <th
                      className={Styles.tableHead + " contentFont text-center"}
                    >
                      S.No
                    </th>
                    <th
                      className={Styles.tableHead + " contentFont text-start"}
                    >
                      Customer Name
                    </th>
                    <th
                      className={Styles.tableHead + " contentFont text-start"}
                    >
                      Customer Mobile
                    </th>
                    <th
                      className={Styles.tableHead + " contentFont text-start"}
                    >
                      Product Name
                    </th>
                    <th
                      className={Styles.tableHead + " contentFont text-start"}
                    >
                      Brand Name
                    </th>
                    <th
                      className={Styles.tableHead + " contentFont text-start"}
                    >
                      Units
                    </th>
                    <th
                      className={Styles.tableHead + " contentFont text-start"}
                    >
                      Description
                    </th>
                    <th
                      className={Styles.tableHead + " contentFont text-start"}
                    >
                      Date
                    </th>

                    <th
                      className={Styles.tableHead + " contentFont text-center"}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.items !== undefined &&
                    tableData.items.length > 0 &&
                    tableData.items.map((e, index) => (
                      <tr key={e.suggestion_id}>
                        <td className="text-center contentFont">
                          {(tableData.page - 1) * tableData.size + (index + 1)}
                        </td>
                        <td className="text-start contentFont">
                          {e.customer_name}
                        </td>
                        <td className="text-start contentFont">
                          {e.customer_mobile}
                        </td>
                        <td className="text-start contentFont">{e.name}</td>
                        <td className="text-start contentFont">
                          {e.brand_name ? e.brand_name : "-"}
                        </td>
                        <td className="text-start contentFont">
                          {e.units ? e.units : "-"}
                        </td>
                        <td className="text-start contentFont">
                          {e.description ? e.description : "-"}
                        </td>
                        <td className="text-start contentFont">
                          {e.date_time}
                        </td>

                        <td className="text-center">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip>Delete</Tooltip>}
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              className={Styles.historyImg}
                              style={{ width: "16px" }}
                              onClick={() =>
                                setShowDelete({ status: true, data: e })
                              }
                            />
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}

                  {tableData?.items?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={9}
                        className="fs-6 text-center text-secondary p-3"
                      >
                        No data found
                      </td>
                    </tr>
                  ) : null}

                  {tableData === null && !isLoader ? (
                    <tr>
                      <td
                        colSpan={9}
                        className="fs-6 text-center text-secondary p-3"
                      >
                        Something went wrong. Please try again.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </div>

          <div
            style={{
              display: (tableData?.total ?? 0) <= 10 ? "none" : "flex",
            }}
            className={Styles.paginationContainer}
          >
            <ReactPaginate
              previousLabel={<img src={LeftArrow} alt="left" />}
              nextLabel={<img src={RightArrow} alt="right" />}
              breakLabel="..."
              pageCount={Math.ceil((tableData?.total ?? 0) / 10)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={({ selected }) =>
                suggestionsListApiCall(selected + 1)
              }
              containerClassName={"pagination m-0"}
              pageClassName={"page-item"}
              pageLinkClassName={
                "page-link text-secondary rounded-circle bg-light pt-1 pb-1 ps-2 pe-2 ms-1 me-1 border-0 shadow-none"
              }
              forcePage={page}
              previousClassName={"page-item"}
              previousLinkClassName={
                "page-link border-0 text-dark p-1 rounded-circle bg_orange shadow-none me-1"
              }
              nextClassName={"page-item"}
              nextLinkClassName={
                "page-link border-0 text-dark p-1 bg_orange rounded-circle shadow-none ms-1"
              }
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
